import i18n from "@/lang";
import _ from "lodash";
import moment from "moment";

const formater = {
  thousand: (value) => {
    return value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  },
  decimal: (value, options) => {
    if (typeof value == "undefined" || value == null || value.length == 0) {
      return "";
    }

    // API錯誤 都回--.--
    if (value == "--.--") {
      return "--.--";
    }

    if (isNaN(value)) {
      return "NaN";
    }

    value = options ? Number(value).toFixed(options[0]) : Number(value);

    return formater.thousand(value);
  },
  floor: (value, options) => {
    if (typeof value == "undefined" || value == null || value.length == 0) {
      return "";
    }

    if (isNaN(value)) {
      return "NaN";
    }

    value = Number(value).toFixed(4);
    let arrayNum = value.toString().split(".");

    let num = value.toString();
    if(!arrayNum[1]){
      num = num+".0000";
    }else{
      for (let index = arrayNum[1].length; index < 4; index++) {
        num = num+"0";
      }
    }
   

    return formater.thousand(num.slice(0,options));
  },
  unit: (value, options) => {
    if (value.length == 0) {
      return '';
    }
    return value + options[0];
  },
  account: (value, options) => {
    return value > 0
      ? '<span class="' + options[0] + '"></span>'
      : '<span class="' + options[1] + '"></span>';
  },
  level: (value) => {
    return "Lv." + value;
  },
  percent: (value) => {
    if (isNaN(value)) {
      return '';
    }
    return formater.decimal(value * 100, [2]) + "%";
  },
  percentWithNoIcon: (value) => {
    if (isNaN(value)) {
      return '';
    }
    return formater.decimal(value, [2]);
  },
  hierarchy: (value) => {
    return (
      value + (i18n.te("enum.format.hierarchy") ? i18n.t("enum.format.hierarchy") : "階")
    );
  },
  prefix: (value, options) => {
    return options[0] + value;
  },
  date: (value, options) => {
    let pattern = options[0] ? options[0] : 'YYYY-MM-DD hh:mm:ss';
    return moment(value).format(pattern);
  }
};

const fmtMap = {
  percent() {
    return "0.00%";
  },
  decimal(options) {
    let fmt = "#,##0";
    if (options[0]) {
      fmt = fmt + "." + _.pad("", options[0], "0");
    }
    return fmt;
  },
};

export default {
  ...formater,
  check: (format) => {
    let [name] = format.split(":");
    return name in formater;
  },
  format: (value, formats) => {
    formats = Array.isArray(formats) ? formats : formats.split("|");

    formats.forEach((format) => {
      let [name, options] = format.split(":");

      options = options ? options.split(",") : options;

      if (formater[name]) {
        value = formater[name](value, options);
      }
    });

    return value;
  },
  has: (name, formats) => {
    formats = Array.isArray(formats) ? formats : formats.split("|");
    let names = formats.map((x) => {
      return x.split(":")[0];
    });
    return names.indexOf(name) > -1;
  },
  toXlsxFmt: (formats) => {
    formats = Array.isArray(formats) ? formats : formats.split("|");

    let opt = {};

    formats.forEach((format) => {
      let [name, options] = format.split(":");
      options = options ? options.split(",") : [];

      if (fmtMap[name]) {
        opt.numFmt = fmtMap[name](options);
      }
    });

    return opt;
  },
};
